<template>
  <v-app>
    <!-- pages-core-app-bar /-->

    <pages-core-view />

    <!-- pages-core-footer /-->
  </v-app>
</template>

<script>
  export default {
    name: 'PagesIndex',

    components: {
      PagesCoreAppBar: () => import('@/components/pages/core/AppBar'),
      PagesCoreFooter: () => import('@/components/pages/core/Footer'),
      PagesCoreView: () => import('@/components/pages/core/View'),
    },

    created () {
      this.$vuetify.theme.dark = false
    },

    beforeDestroy () {
      this.$vuetify.theme.dark = false
    },
  }
</script>
